import React, { useEffect, useState } from 'react';
import './electionList.css';
import { userAPI } from '../API/api';
import Header from '../Header/header';
import { useNavigate } from 'react-router-dom';

const RunningElections = () => {
  const [elections, setElections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [voting, setVoting] = useState(false);
  const userId = localStorage.getItem('userId'); // set this on login!
const navigate = useNavigate()
  useEffect(() => {
    const fetchElections = async () => {
      try {
        const response = await userAPI.get('/vote/elections/running');
        setElections(response.data);
        if (response.data.length ===0){
              navigate('/leaderboard')
        }
      } catch (error) {
        console.error('Error fetching elections:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchElections();
  }, []);

  const handleVote = async (electionId, candidateId) => {
    setVoting(true);
    try {
      const res = await userAPI.post(`/vote/vote/${electionId}/`, {
        userid: candidateId
      });
      alert('Vote submitted successfully!');
       window.location.reload();
      
    } catch (err) {
      console.error('Vote error:', err);
      alert('Failed to submit vote.');
    } finally {
      setVoting(false);
    }
  };

  if (loading) return <div className="loading">Loading elections...</div>;

  return (
    <div className="elections-container">
      <Header />
      <h2 className="section-title">Running Elections</h2>
      {elections.length === 0 ? (
        <p>No available election for you to vote.</p>
      ) : (
        elections.map((election) => (
          <div key={election.id} className="election-card animate-fade">
            <h3 className="election-title">{election.election_name}</h3>
            {/* <p><strong>Status:</strong> {election.is_open ? 'Open' : 'Closed'}</p> */}
            <div className="candidates">
              <h4>Candidates:</h4>
              <ul>
                {election.candidate
                  .filter((c) => c.name.trim() !== '')
                  .map((c) => (
                    <li key={c.id} className="candidate-item">
                      <span>{c.name}</span>
                      <button
                        disabled={voting || !election.is_open}
                        onClick={() => handleVote(election.id, c.id)}
                        className="vote-btn"
                      >
                        Vote
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default RunningElections;
